export enum UserAccessType {
    Read = 0,
    ReadWrite = 1
  }
